import { Components, Theme } from '@mui/material/styles';

import { headerHeight, spacing } from '../constants/layout';

export const snackbarConfigs: Components<Theme>['MuiSnackbar'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&.MuiSnackbar-anchorOriginTopCenter': {
        top: headerHeight.xs + spacing * 3,
      },

      '.MuiSnackbarContent-root': {
        background: theme.palette.background.paper,
        color: theme.palette.text.primary,
        flexGrow: 'initial',
        flexDirection: 'row',
        padding: spacing * 2,

        '.MuiSnackbarContent-message': {
          padding: 0,
          alignItems: 'center',
          display: 'flex',
          gap: spacing * 1,

          '.MuiIconButton-root': {
            padding: theme.spacing(0.5),
            marginRight: theme.spacing(-0.5),

            '.MuiSvgIcon-root': {
              fill: theme.palette.common.white,
              height: 20,
              width: 20,
            },
          },
        },
      },

      '&.toast-info .MuiSnackbarContent-root': {
        background: theme.palette.info.main,
        color: theme.palette.info.contrastText,
        '.MuiSvgIcon-root': {
          fill: theme.palette.info.contrastText,
        },
      },
      '&.toast-error .MuiSnackbarContent-root': {
        background: theme.palette.error.main,
        color: theme.palette.error.contrastText,
        '.MuiSvgIcon-root': {
          fill: theme.palette.error.contrastText,
        },
      },
      '&.toast-success .MuiSnackbarContent-root': {
        background: theme.palette.success.main,
        color: theme.palette.success.contrastText,
        '.MuiSvgIcon-root': {
          fill: theme.palette.success.contrastText,
        },
      },
    }),
  },
};
